import { Box, Button, Tab, Tabs } from "@mui/material";
import dayjs from "dayjs";
import { showError } from "helpers";
import MainContainer from "layout/MainContainer";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetBookingsByIdQuery } from "service/booking";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

enum BOOKING_STATUS {
  PENDING = 1,
  ONGOING = 2,
  CONFIRMED = 3,
  CANCELLED = 4,
  COMPLETED = 5,
  FAILED = 6,
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BookingDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getBookingsDetails] = useLazyGetBookingsByIdQuery();

  const [valueTabs, setValueTabs] = useState(0);
  const [loading, setLoading] = useState(false);
  const [bookings, setBookings] = useState<any>(null);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getBookingsDetailsApi = async () => {
    setLoading(true);
    try {
      const response = await getBookingsDetails({
        id,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBookings(response?.data);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getBookingsDetailsApi();
  }, []);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Booking Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Bookings - Booking Details
          </p>
        </div>

        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <Box className="custom_tabs2" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Customer Information" {...a11yProps(0)} />
          <Tab label="Booking Information" {...a11yProps(1)} />
          <Tab label="Vehicles Details" {...a11yProps(3)} />
          <Tab label="Price Details" {...a11yProps(4)} />
        </Tabs>
      </Box>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div>
            <div className="profileInfo_head">
              <h2>Customer Detail</h2>
            </div>
            <div className="profileInfo_list">
              <ul className="text_info gap_p">
                <li className="w_50">
                  <strong>Name</strong>
                  <span>{`${bookings?.user?.firstName || "-"} ${bookings?.user?.lastName || ""}`}</span>
                </li>
                <li className="w_50">
                  <strong>E-mail</strong>
                  <span>{bookings?.user?.email || "-"}</span>
                </li>
                <li className="w_50">
                  <strong>Phone</strong>
                  <span>{`${bookings?.user?.countryCode || ""} ${bookings?.user?.phone || "-"}`}</span>
                </li>
              </ul>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div>
            {" "}
            <div className="profileInfo_head">
              <h2>Booking Information</h2>
            </div>
            <div className="profileInfo_list">
              <ul className="text_info gap_p">
                <li className="w_50">
                  <strong>Booking Date & Time</strong>
                  <span>
                    {dayjs(bookings?.items[0]?.rentalStart).format(
                      "DD MMM, YYYY"
                    )}
                  </span>
                </li>
                <li className="w_50">
                  <strong>Return Date</strong>
                  <span>
                    {dayjs(bookings?.items[0]?.rentalEnd).format(
                      "DD MMM, YYYY"
                    )}
                  </span>
                </li>
                <li className="w_50">
                  <strong>Status</strong>
                  <span>
                    {bookings?.status === BOOKING_STATUS.PENDING
                      ? "Pending"
                      : bookings?.status === BOOKING_STATUS.CONFIRMED
                        ? "Confirmed"
                        : bookings?.status === BOOKING_STATUS.COMPLETED
                          ? "Completed"
                          : bookings?.status === BOOKING_STATUS.FAILED
                            ? "Failed"
                            : bookings?.status === BOOKING_STATUS.CANCELLED
                              ? "Cancelled"
                              : "Approved"}
                  </span>
                </li>

                {/* <li className="w_50">
                  <strong>Location</strong>
                  <span>dubai</span>
                </li> */}
              </ul>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div>
            <div className="profileInfo_head">
              <h2>Vehicle Details</h2>
            </div>
            <div className="profileInfo_list">
              <ul className="text_info gap_p">
                <li className="w_50">
                  <strong>Name</strong>
                  <span>
                    {bookings?.items[0]?.carDetails?.title?.en || "-"}{" "}
                  </span>
                </li>
                <li className="w_50">
                  <strong>Model</strong>
                  <span>
                    {bookings?.items[0]?.carDetails?.specs?.modelYear ||
                      "-"}{" "}
                  </span>
                </li>
                <li className="w_50">
                  <strong>Brand</strong>
                  <span>
                    {bookings?.items[0]?.carDetails?.brand?.name?.en ||
                      "-"}{" "}
                  </span>
                </li>

                <li className="w_50">
                  <strong>Class</strong>
                  <span>
                    {bookings?.items[0]?.carDetails?.class?.name?.en ||
                      "-"}{" "}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <div>
            <div className="profileInfo_head">
              <h2>Price Details</h2>
            </div>
            <div className="profileInfo_list">
              <ul className="text_info gap_p">
                <li className="w_50">
                  <strong>Base Amount</strong>
                  <span>
                    AED {bookings?.items[0]?.price?.baseAmount || "0"}
                  </span>
                </li>
                <li className="w_50">
                  <strong>Delivery Charges</strong>
                  <span>
                    AED {bookings?.items[0]?.price?.deliveryCharges || "0"}
                  </span>
                </li>

                <li className="w_50">
                  <strong>Tax</strong>
                  <span>AED {bookings?.items[0]?.price?.tax || "0"}</span>
                </li>

                <li className="w_50">
                  <strong>Total Amount</strong>
                  <span>
                    AED {bookings?.items[0]?.price?.finalAmount || "0"}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default BookingDetails;
